import React, { Component } from 'react';
import './page.scss';

import queryString from 'query-string';
import axios from 'axios';
import moment from 'moment';

import { AutoSizer, Column, Table } from 'react-virtualized';
import 'react-virtualized/styles.css';
import { getQs } from 'services/queryString'

// components
import Loader from '../components/Loader/Loader';


// Download data
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      sales: [],
      xlsDataset: [],
      orderDesc: false,
      apiError: false,
      // path and params
      apiPath: null,
      entity: null, // affiliate/seller/supplier
      id: null,
      startDate: null,
      endDate: null,
      // ui
      showDownloadMenu: false,
      savingFile: false
    };

    this.headerRender = this.headerRender.bind();
    this.cellRender = this.cellRender.bind();

    this.onDownloadMenuClickOutside = this.onDownloadMenuClickOutside.bind(
      this
    );
  }

  componentWillMount() {
    const {
      path,
      params: { id }
    } = this.props.match;
    const { from, to } = queryString.parse(this.props.location.search);
    this.setState({ apiPath: path, id, startDate: from, endDate: to });
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.onDownloadMenuClickOutside);
    const { apiPath, id, startDate, endDate } = this.state;
    if (id && this.parametersAreValid(startDate, endDate) && apiPath) {
      this.setState({ loading: true }, () => {
        const apiUrl = this.buildApiUrl(apiPath, id, startDate, endDate);
        if (apiUrl) {
          const token = getQs("token")
          axios
            .get(
              apiUrl,
              token
                ? {
                    headers: { authorization: `Bearer ${getQs("token")}` },
                  }
                : undefined
            )
            .then((res) => {
              if (res && res.status === 200) {
                this.setState({
                  loading: false,
                  apiError: false,
                  sales: res.data || [],
                  xlsDataset: this.salesToXlsxDataset(res.data || []),
                });
              } else {
                this.setState({ loading: false, apiError: true });
              }
            });
        }
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onDownloadMenuClickOutside);
  }

  onDownloadMenuClickOutside(event) {
    if (this.downloadMenuRef && !this.downloadMenuRef.contains(event.target)) {
      this.setState({ showDownloadMenu: false });
    }
  }

  salesToXlsxDataset(sales) {
    if (!sales || sales.length === 0) return [];

    const columns = Object.keys(sales[0]);
    const dataset = [
      {
        columns,
        data: sales.map(s => {
          return Object.values(s);
        }),
      }
    ];
    return dataset;
  }

  buildApiUrl(apiPath, id, startDate, endDate) {
    let entity = null;
    let url = null;
    if (apiPath.includes('affiliates')) {
      entity = 'affiliate';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Affiliate_Sales?idAffiliate=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else if (apiPath.includes('suppliers')) {
      entity = 'supplier';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Supplier_Sales?uuidSupplier=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else if (apiPath.includes('sellers')) {
      entity = 'seller';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Seller_Sales?idSeller=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else if (apiPath.includes('account')) {
      entity = 'account';
      url = `https://business-api.musement.com/api/reports/DWH/_proc/rpt_Account_Sales?uuidAccount=${id}&dtBookedStart=${startDate}&dtBookedEnd=${endDate}&SortBy=1&Sorting=ASC`;
    } else return null;
    this.setState({ entity });

    return url;
  }

  orderByFilter(label) {
    const { sales, orderDesc } = this.state;
    const orderedSales = sales;
    orderedSales.sort((a, b) => {
      if (moment(a[label], 'YYYY-MM-DD', true).isValid()) {
        if (orderDesc) return new Date(a[label]) - new Date(b[label]);
        return new Date(b[label]) - new Date(a[label]);
      } else {
        if (orderDesc) return a[label] - b[label];
        return b[label] - a[label];
      }
    });

    this.setState({ sales: orderedSales, orderDesc: !orderDesc });
  }

  parametersAreValid(startDate, endDate) {
    return (
      startDate &&
      endDate &&
      moment(startDate, 'YYYY-MM-DD', true).isValid() &&
      moment(endDate, 'YYYY-MM-DD', true).isValid()
    );
  }

  downloadAsPDF(entity, id) {
    this.setState({ showDownloadMenu: false, savingFile: true }, () => {
      document.body.style.overflow = 'hidden';
      const input = document.getElementById('dataTable');
      html2canvas(input).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        var imgWidth = 210;
        var pageHeight = 280;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jsPDF('p', 'mm', 'a4');
        var position = 0;
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        this.setState({ savingFile: false }, () => {
          doc.save(`${entity}-${id}.pdf`);
          document.body.style.overflow = 'auto';
        });
      });
    });
  }

  // UI

  headerRender({ label }) {
    return <div className="page-tableheader">{label}</div>;
  }

  cellRender({ cellData }) {
    // const value = isNaN(cellData) ? cellData : cellData.toFixed(2);
    // return <div className="page-tablecolumn">{value || ''}</div>;

    const isDate = moment(cellData, 'YYYY-MM-DD', true).isValid();
    if (isDate) {
      return <div className="page-tablecolumn">{moment(cellData).format('DD/MM/YYYY') || ''}</div>;
    } else {
      return <div className="page-tablecolumn">{cellData || ''}</div>;
    }
  }

  getTableColumns(column, index) {
    return (
      <Column
        key={index}
        label={column}
        dataKey={column}
        width={200}
        headerRenderer={this.headerRender}
        cellRenderer={this.cellRender}
      />
    );
  }

  render() {
    const {
      loading,
      savingFile,
      entity,
      id,
      sales,
      xlsDataset,
      startDate,
      endDate,
      showDownloadMenu
    } = this.state;

    const columns = sales.length >= 1 ? Object.keys(sales[0]) : [];
    const HEADER_HEIGTH = 40;
    const ROW_HEIGTH = 60;

    if (loading) return <Loader label="Loading..." />;

    if (!this.parametersAreValid(startDate, endDate)) {
      return (
        <div className="page full-height">
          <p className="page-error">Invalid startDate or endDate parameters.</p>
        </div>
      );
    }

    return (
      <div className="page">
        {savingFile && <Loader label="Exporting file..." />}
        <div className="page-header">
          <p className="page-header--title" />
          <div
            className="page-header--exportbutton"
            onClick={() =>
              this.setState({ showDownloadMenu: !this.state.showDownloadMenu })
            }
          >
            Download as
          </div>
          {showDownloadMenu && (
            <div className="page-downloadmenu" ref={node => (this.downloadMenuRef = node)}>
              <CSVLink data={sales} filename={`${entity} -${id}.csv`} target="_blank">
                CSV
              </CSVLink>
              <ExcelFile filename={`${entity}-${id}`} element={<button className="page-downloadmenu--pdf">XLS</button>}>
                <ExcelSheet dataSet={xlsDataset} name="Report" />
              </ExcelFile>
              <button className="page-downloadmenu--pdf" onClick={() => this.downloadAsPDF(entity, id)}>PDF</button>
            </div>
          )}
        </div>
        <div id="dataTable">
          {sales.length >= 1 && (
            <AutoSizer disableHeight>
              {({ width }) => (
                <Table
                  width={width}
                  height={sales.length * ROW_HEIGTH + HEADER_HEIGTH} // item height === 60px
                  headerHeight={HEADER_HEIGTH}
                  rowHeight={ROW_HEIGTH}
                  rowCount={sales.length}
                  rowGetter={({ index }) => sales[index]}
                  rowStyle={({ index }) => {
                    return index % 2 === 0
                      ? { backgroundColor: '#ffffff', borderTop: "1px solid #dce4e6" }
                      : { backgroundColor: '#fafafa', borderTop: "1px solid #dce4e6" };
                  }}
                  // onRowClick={({ rowData }) => console.log('[List.js ==> row click]', rowData)}
                  onHeaderClick={({ dataKey }) => this.orderByFilter(dataKey)}
                >
                  {columns.map((c, index) => this.getTableColumns(c, index))}
                </Table>
              )}
            </AutoSizer>
          )}
        </div>
      </div>
    );
  }
}

export default List;
